import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

export const diceApi = createApi({
  reducerPath: 'diceApi',
  baseQuery: dynamicBaseQuery,
  tagTypes: ['Dice'],
  endpoints: (builder) => ({
    getDiceCurrentRound: builder.query({
      query: () => ({
        url: '/api/dice/current-round',
        method: 'GET',
      }),
      providesTags: ['Dice'],
    }),

    getDiceResults: builder.query({
      query: () => ({
        url: '/api/dice/results',
        method: 'GET',
      }),
      providesTags: ['Dice'],
    }),

    getDiceInplayBets: builder.query({
      query: (game = 'dice') => ({
        url: `/api/game/admin/inplay-bets?game=${game}`,
        method: 'GET',
      }),
      providesTags: ['Dice'],
    }),

    getDiceRoundsByDate: builder.query({
      query: ({ fromDate, toDate, page = 1, limit = 20 }) => ({
        url: `/api/dice/admin/rounds?fromDate=${fromDate}&toDate=${toDate}&page=${page}&limit=${limit}`,
        method: 'GET',
      }),
      providesTags: ['Dice'],
    }),

    getDiceRoundBets: builder.query({
      query: ({ roundId, page = 1, limit = 20 } = {}) => {
        const params = new URLSearchParams({ page, limit });
        if (roundId) params.append('roundId', roundId);
        return {
          url: `/api/dice/admin/round-bets?${params.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['Dice'],
    }),
  }),
});

export const {
  useGetDiceCurrentRoundQuery,
  useGetDiceResultsQuery,
  useGetDiceInplayBetsQuery,
  useGetDiceRoundBetsQuery,
  useGetDiceRoundsByDateQuery,
} = diceApi;

export default diceApi;
